import React, { useState } from 'react';
import Layout from "../components/App/Layout";
import Navbar from "../components/App/Navbar";
import PageBanner from '../components/Common/PageBanner';
import Footer from "../components/App/Footer";
import SEO from "../components/App/SEO";

import ai_image from '../assets/images/ai_image.jpg';
import ai_banner2 from '../assets/images/ai-banner2.jpg';
import bb_banner3 from '../assets/images/bb_banner3.jpg';
import bub3 from '../assets/images/bub3.png';
import bub4 from '../assets/images/bub4.png';
import bubble from '../assets/images/bubble.png';

import Custom_aps from '../assets/images/Custom_aps.png';
import data_preparation from '../assets/images/data_preparation.png';
import Industry_pecific from '../assets/images/Industry_pecific.png';
import Integration from '../assets/images/Integration.png';
import Ongoing_support from '../assets/images/Ongoing_support.png';
import Text_image from '../assets/images/Text_image.png';

// Add these imports at the top with other image imports
import step1_icon from '../assets/images/step1.png';
import step2_icon from '../assets/images/step2.png';
import step3_icon from '../assets/images/step3.png';
import step4_icon from '../assets/images/step4.png';
import step5_icon from '../assets/images/step5.png';
import dotsBgImage from "../assets/images/Group 148461.png"

import Agriculture from '../assets/images/Agriculture.png';
import Automotive from '../assets/images/Automotive.png';
import Education from '../assets/images/Education.png';
import Energy from '../assets/images/Energy.png';
import Finance from '../assets/images/Finance.png';
import Government_public_sector from '../assets/images/Government_public_sector.png';
import Healthcare from '../assets/images/Healthcare.png';
import Legal_compliance from '../assets/images/Legal_compliance.png';
import Logistics from '../assets/images/Logistics.png';
import Manufacturing from '../assets/images/Manufacturing.png';
import Media from '../assets/images/Media.png';
import Retail from '../assets/images/Retail.png';
import Swal from 'sweetalert2';
import consistent from '../assets/images/consistent.png';
import phonecall from '../assets/images/phonecall.png';
import FunfactComponent from "../components/DynamicPages/FunfactComponent"
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
const sendEmail = async (e) => {
  e.preventDefault();

  const name = e.target.elements.name.value;
  const email = e.target.elements.email.value;
  const message = e.target.elements.message.value;
  const technology = e.target.elements.technology.value;

  const messageBody = `
Hi,

Name: ${name}
Phone No: ${email}
Message: ${message}
Technology: ${technology}
`;

  console.log("Sending message:", messageBody);

  try {
    const response = await fetch('https://p8t29dandg.execute-api.ap-south-1.amazonaws.com/prod', {
      method: "POST",
      mode: "cors", // changed from "no-cors" to allow errors & full communication
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        messageBody
      }),
    });

    if (!response.ok) {
      throw new Error(`Server error: ${response.status}`);
    }

    // Optional: parse JSON response if applicable
    // const data = await response.json();

    // Success alert
    Swal.fire('Mail Sent Successfully!', '', 'success');
    window.location.reload(false);

  } catch (error) {
    console.error("Error sending email:", error);
    Swal.fire('Error sending mail', error.message || 'Please try again later.', 'error');
  }
};

const services = [
  {
    title: "Custom Web App Development",
    text: "We design and develop fully functional web applications tailored to your goals, built 100% in Bubble.",
    topics: [
      "MVPs & Prototypes",
      "SaaS Platforms",
      "<b>Client Portals & Dashboards"
    ],
    icon: Custom_aps,
  },
  {
    title: "API Integration",
    text: "We connect your Bubble app to any external tool or platform—CRMs, payment gateways, ERPs, AI APIs, and more.",
    topics: [
      "<b>Stripe, PayPal, Razorpay</b>",
      "<b>OpenAI, Zapier, Airtable</b>",
      "<b>RESTful & GraphQL APIs</b>"
    ],
    icon: Text_image,
  },
  {
    title: "Marketplace & Directory Platforms",
    text: "From booking systems to talent directories, we build scalable multi-user platforms with rich user roles.",
    topics: [
      "Admin Panels",
      "Multi-Vendor Logic",
      "Search & Filter Systems"

    ],
    icon: Industry_pecific,
  },
  {
    title: "Internal Business Tools",
    text: "We build secure, custom back-office solutions that replace spreadsheets and manual work.",
    topics: [
      "Inventory Management",
      "HR/Employee Tools",
      "Workflow Automation"
    ],
    icon: Integration,
  },
  {
    title: "Marketplace & Directory Platforms",
    text: "From booking systems to talent directories, we build scalable multi-user platforms with rich user roles.",
    topics: [
      "Admin Panels",
      "Multi-Vendor Logic",
      "Search & Filter Systems"

    ],
    icon: Industry_pecific,
  },
  {
    title: "Mobile-Friendly Web Apps",
    text: "All our Bubble apps are responsive and optimized for mobile, tablet, and desktop.",
    topics: [
      "Adaptive Layouts",
      "Cross-Device Consistency",
      "PWA Support"

    ],
    icon: Industry_pecific,
  },
  {
    title: "Bubble App Redesign & Optimization",
    text: "Already using Bubble? We help upgrade your UI, optimize workflows, and refactor databases.",
    topics: [
      "App Speed Optimization",
      "UX Redesign",
      "Workflow Debugging"

    ],
    icon: Industry_pecific,
  },
  {
    title: "Bubble Development Services Typically Include",
    text: "",
    topics: [
      "Product Ideation & Technical Scoping",
      "UX/UI Design for Web App",
      "Database Architecture",
      "Custom Workflows & Logic",
      "Responsive Layouts",
      "Plugin Setup & API Connections",
      "Third-Party Tool Integration",
      "Bubble Coaching & Consulting"

    ],
    icon: Industry_pecific,
  },
  {
    title: "Benefits of Choosing Bubble",
    text: "",
    topics: [
      "<b>Rapid Development::</b> Build and launch MVPs in weeks, not months.",
      "<b>Cost-Effective</b>: No need for a large development team.",
      "<b>Full Customization</b>: Tailor every element to your business logic.",
      "<b>Visual Programming</b>: Manage logic, design, and data—all without code.",
      "<b>Scalable Architecture</b>: Grow from MVP to full-scale app.",
      "<b>Robust Integrations</b>: Seamlessly connect with CRMs, databases, AI, and more.",
      "<b>Quick Iterations:</b>: Test, improve, and relaunch faster than traditional dev cycles.",
      "<b>Ownership & Control:</b>:You get access to the full app backend."

    ],
    icon: Industry_pecific,
  },
];


const industries = [
  {
    title: "Startups & Founders",
    icon: Finance,
  },
  {
    title: "SaaS & B2B Platforms",
    icon: Manufacturing,
  },
  {
    title: "EdTech & Learning Platforms",
    icon: Media,
  },
  {
    title: "Healthcare & MedTech",
    icon: Retail,
  },
  {
    title: "Finance & InsurTech",
    icon: Energy,
  },
  {
    title: "Real Estate & PropTech",
    icon: Legal_compliance,
  },
  {
    title: "Marketplaces & Communities",
    icon: Automotive,
  },
  {
    title: "Logistics & Fleet Management",
    icon: Healthcare,
  },
  {
    title: "NGOs & Government Platforms",
    icon: Agriculture,
  },
  {
    title: "LegalTech & Compliance",
    icon: Logistics,
  },
  {
    title: "HR & Employee Portals",
    icon: Education,
  },
  {
    title: "Internal Tools for Enterprises",
    icon: Government_public_sector,
  },

];

// Update the executionSteps array to include icons
const executionSteps = [
  { text: "Project Discovery & Requirement Mapping", icon: step1_icon },
  { text: "UX/UI Design", icon: step2_icon },
  { text: "No-Code Development in Bubble", icon: step3_icon },
  { text: "Third-Party Integration & APIs", icon: step4_icon },
  { text: "Testing & Quality Assurance", icon: step5_icon },
  { text: "Handover, Training & Launch", icon: step5_icon }
];

const faqData = [
  {
    question: 'What AI development services do you offer?',
    answer: 'We offer services like natural language processing, machine learning model development, computer vision, AI consulting, and custom AI solution development.',
  },
  {
    question: 'How can AI benefit my business?',
    answer: 'AI can streamline operations, improve customer service, provide predictive analytics, and automate routine tasks, increasing overall efficiency and innovation.',
  },
  {
    question: 'What industries do you specialize in?',
    answer: 'We specialize in healthcare, finance, e-commerce, manufacturing, and logistics, among other industries.',
  },
];


const IotDevelopment = () => {

  const [openIndex, setOpenIndex] = useState(null);

  const toggleIndex = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <Layout>
      <SEO
        title="Bubble No-Code Development Services | Custom Web App Builder | SrashtaSoft"
        description="Hire expert Bubble.io developers to build custom web applications, SaaS platforms, and MVPs fast with no-code. We offer full-stack Bubble development and API integrations."
        canonical="https://srashtasoft.com/bubble-development/"
        isServicePage
        serviceName="Bubble No-Code Development Services"
        faqData={faqData}
      />
      <Navbar />
      <PageBanner
        pageTitle="Bubble Development Services"
        homePageText="Home"
        homePageUrl="/"
        activePageText="Bubble Development Services"
      />

      {/* Intro Section */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-md-6">
              <h2 className="h1 fw-bold text-headings mb-4">
                Build Custom Apps Fast — No-Code, No Compromise
              </h2>
              <p className="text-secondary mb-3">
                We are a team of product thinkers, designers, and Bubble developers passionate about turning your business ideas into fully functional digital products—without writing traditional code. Our mission is to empower startups, enterprises, and innovators with powerful web apps using Bubble’s visual programming platform.
              </p>
              <p className="text-secondary mb-4">
                Whether you're launching an MVP, automating internal workflows, or scaling a SaaS platform, Bubble lets us build robust, responsive, and dynamic applications faster, while saving you time, money, and complexity.
              </p>
              <a href="/contact-us" className="btn btn-white px-4 py-2" style={{
                color: "#1A2B5F",
                border: "0.6px solid #1A2B5F",
                textDecoration: "none" // optional, to remove underline
              }}>
                Let’s Talk About Your Requirements
              </a>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-6">
                  <img src={bub3} loading="lazy" className="img-fluid rounded shadow" alt="Generative AI Illustration 1" />
                </div>
                <div className="col-6">
                  <img src={bub3} loading="lazy" className="img-fluid rounded shadow" alt="Generative AI Illustration 2" />
                </div>
                <div className="col-12 pt-4">
                  <img src={bub4} loading="lazy" className="img-fluid rounded shadow" alt="Generative AI Illustration 3" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Banner CTA */}
      <section className="py-5 text-white position-relative" style={{
        background: `url(${ai_banner2}) no-repeat center center/cover`,
        height: "350px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "#007bff40",
          zIndex: 1
        }}></div>

        <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start" style={{ position: "relative", zIndex: 2 }}>
          <h2 className="h3 fw-bold mb-4 mb-md-0" style={{ fontSize: "46px" }}>
            We've Developed SaaS Platforms, Marketplaces, <br />CRMs, & Internal Tools<br /> — All with Bubble

          </h2>
          <a href="/contact-us/" className="btn btn-light fw-semibold text-dark" style={{
            fontWeight: 500,
            fontSize: "16px",
            lineHeight: "24px",
            letterSpacing: "2%",
            width: "180PX",
            height: "56",
            borderRadius: "6px"
          }}>
            Let’s talk Now!
          </a>
        </div>
      </section>

      {/* Services */}
      {/* Services */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="mb-5 fw-bold text-center" style={{ color: "#1A2B5F", fontSize: "40px" }}>Bubble Services</h2>
          <div className="row g-4">
            {services.map((service, index) => (
              <div className="col-md-6 col-lg-6" key={index} style={{ marginTop: "30px" }}>
                <div className="card h-100 shadow-sm">
                  <div className="card-body">
                    <img src={service.icon} loading="lazy" className="mb-3" alt={service.title} />
                    <h5 className="card-title">{service.title}</h5>
                    <p className="card-text text-muted">{service.text}</p>
                    {service.topics && (
                      <ul className="list-unstyled mt-3">
                        {service.topics.map((topic, topicIndex) => (
                          <li key={topicIndex} className="mb-2" style={{
                            display: 'flex',
                            alignItems: 'flex-start'
                          }}>
                            <span dangerouslySetInnerHTML={{ __html: topic }} />
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries */}
      <section className="py-5 bg-white">
        <div className="container text-center">
          <h2 className="fw-bold mb-4" style={{ color: "#1A2B5F" }}>Industries We Serve</h2>
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-6 g-4">
            {industries.map((industry, index) => (
              <div className="col" key={index} style={{
                height: "160px !important",
                marginTop: "24px"
              }}>
                <div className="p-4 shadow-sm h-100 text-center" style={{ borderRadius: "12px", border: "1px solid #E3E3E3" }}>
                  <img
                    src={industry.icon}
                    alt={industry.title}
                    className="mb-3"
                    loading="lazy"
                    style={{ width: "50px", height: "50px", objectFit: "contain" }}
                  />
                  <h5 className="fw-semibold font_size mb-2">{industry.title}</h5>
                  <p className="text-muted small mb-0">{industry.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Execution Steps */}
      <section className="bg-primary text-white py-5" style={{
        background: `url(${bb_banner3}) no-repeat center center/cover`,
        height: "660px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundBlendMode: "overlay"
      }}>
        <div className="container text-center" style={{ height: "663px", alignContent: "center" }}>
          <h2 className="fw-bold mb-5" style={{
            fontWeight: 700,
            fontSize: "40px",
            lineHeight: "40px",
            letterSpacing: "2%",
            textAlign: "center",
            textTransform: "capitalize"
          }} >How We Execute Your Project</h2>
          <div className="row justify-content-center gy-4" style={{ height: "313px" }}>
            {executionSteps.map((step, index) => (
              <div className="col-6 col-sm-4 col-md-2" key={index} style={index % 2 !== 0 ? { marginTop: "70px" } : {}}>
                <div className="d-flex flex-column align-items-center">
                  <img
                    src={step.icon}
                    alt={step.text}
                    className="mb-3"
                    style={{ width: "155px", height: "155px", objectFit: "contain" }}
                  />
                  <p className="fw-semibold small text-white mb-0" style={{
                    fontWeight: 700,
                    fontSize: "16px",
                    lineHeight: "24px",
                    letterSpacing: "4%",
                    textAlign: "center",
                    verticalAlign: "middle",
                    textTransform: "capitalize"
                  }}>{step.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-5 bg-white">
        <div className="container">
          <h2
            className="text-center fw-bold mb-4"
            style={{
              fontWeight: 700,
              fontSize: "40px",
              lineHeight: "100%",
              letterSpacing: "0%",
              textTransform: "capitalize",
            }}
          >
            FAQs: Bubble Development Services
          </h2>

          <div className="panel-group wrap" id="bs-collapse">

            <Accordion allowZeroExpanded>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Can Bubble really build complex apps?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Yes. Bubble supports logic, workflows, APIs, and database structures—ideal for MVPs, SaaS apps, and business tools.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Do I need coding knowledge to manage the app?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Not at all. Bubble’s visual editor allows you to make changes without writing code.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Can you connect third-party tools like payment gateways or CRMs?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Absolutely. We integrate Bubble with any tool that provides an API.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Is Bubble scalable for long-term use?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Yes. With the right architecture and optimization, Bubble apps can grow to support thousands of users.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </section>
      <FunfactComponent />
      <section className='need-help-section' id='need-help'>
        <div className='container'>
          <div className='row quote-formss'>
            <div className='col-lg-6 col-md-12'>
              <h1>NEED HELP ?</h1>
              <p className='need-paragraph'>Choosing The Right Package</p>
              <div className='row padding-class'>
                <div className='col-md-6'>
                  <div class="icon-need-div">
                    <div class="icon">
                      <img src={consistent} />
                    </div>
                    <p className='normal-p'>	Contact a <strong class="yello-colors"> Bubble WebDevelopment</strong></p>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div class="icon-need-div">
                    <div class="icon">
                      <img src={phonecall} />
                    </div>
                    <p className='normal-p'>	<a classname="ancher-link" href="tel:+(91) 9898582705">Schedule <strong class="yello-colors"> a call with us  </strong></a></p>
                  </div>
                </div>

              </div>
              <span className='heading-text'>+(91) 9898582705</span>
            </div>
            <div className='col-lg-2 col-md-0'></div>
            <div className='col-lg-4 col-md-12'>
              <section id="quote" className="bg-msar msar-quote-form">
                <section className="row">
                  <form onSubmit={sendEmail}>

                    <div className="col-md-12">
                      <div className="mt-4 white-text">Get Your Free</div>
                      <h4 className='white-text'>Consultation &amp; Quote</h4>
                      <div id="frm-quote">
                        <div className="form-group mt-4">
                          <input type="text"
                            className="form-control w-100 border-0"
                            placeholder="Name*"
                            name="name"
                            required
                          // onChange={onInputchange}
                          />
                        </div>

                        <div className="form-group">
                          <input type="text"
                            className="form-control w-100 border-0"
                            placeholder="Email*"
                            name="email"
                            required
                          // onChange={onInputchange}
                          />
                        </div>

                        <div className="form-group">
                          <select class="form-control w-100 border-0 p-2 " name='technology'
                          //  onChange={onInputchange}
                          >
                            <option value="Service">Service Required </option>
                            <option value="ReactJs">ReactJs Development</option>
                            <option value="NodeJs">NodeJs Developement</option>
                            <option value="WordPress">WordPress Development</option>
                            <option value="PHP">PHP Development</option>
                            <option value="Laravel">Laravel Development</option>
                            <option value="Flutter">Flutter Development</option>
                            <option value="Reactnative">React Native Development</option>
                            <option value="Android">Android Development</option>
                            <option value="IOS">IOS Development</option>
                            <option value="graIOTpefruit">IOT Development</option>
                            <option value="UIUX">UI/UX Development</option>
                            <option value="Shopify">Shopify Development</option>
                            <option value="Magento">Magento Development</option>
                            <option value="Layout">Layout Design</option>
                            <option value="Html">Html Development</option>
                            <option value="Logo">Logo Design</option>
                            <option value="Python">Python Development</option>
                          </select>
                        </div>

                        <div className="form-group mb-0">
                          <textarea className="form-group w-100 border-0 p-2 mb-0"
                            rows="2"
                            placeholder="Your Text"
                            // onChange={onInputchange}
                            name="message"
                            required
                          >
                          </textarea>
                        </div>

                        <div className="mt-0 pt-0 small white-text">* Need to fill marked. Make a call more details required.</div>
                        <button type="submit" className="btn-white-custom btn btn-sm mt-3"> Send Message </button>
                      </div>
                    </div>
                  </form>
                </section>
              </section>
            </div>

          </div>
        </div>
      </section>


      <Footer />
      <style jsx>{`
        .service-hero-section {
          min-height: 500px;
          display: flex;
          align-items: center;
        }
        .animation-up-down {
          animation: up-down 3s ease-in-out infinite;
        }
        @keyframes up-down {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-20px); }
        }
        .text-headings {
          color: #0e1133;
        }
        .btn-white {
          background: #fff;
          border: 1px solid #0e1133 !important;
          color: #0e1133 !important;
          transition: 0.3s;
        }
        .btn-white:hover {
          background: #0e1133;
          color: #fff !important;
        }
        .card {
          border-radius: 15px;
          transition: all 0.3s ease;
          border: 1px solid #f0f0f0;
        }
        .card:hover {
          transform: translateY(-10px);
          box-shadow: 0 10px 30px rgba(0,0,0,0.1) !important;
        }
      `}</style>
    </Layout>
  );
};

export default IotDevelopment;
